import { Box, Typography } from "@mui/material";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteFile, downloadAttachment } from "../customerGroupSetupSlice";

export default function CreateAttachments() {
   const dispatch = useDispatch();
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { files } = cgState;

   function handleDeleteFile(file) {
      console.log(file);
      dispatch(deleteFile(file));
   }

   function handleDownloadFile(file) {
      //console.log(file);
      if (file.filePath) {
         dispatch(downloadAttachment({ fileName: file.name ? file.name : file.filePath }));
      }
      else{
      //Before Saving or Submitting the CG, if you want to download the attachment
      // If file is only in the frontend state, create a Blob URL and download it
      const blob = new Blob([file], { type: file.type });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      }   
   }

   return (
      <Box sx={{ mt: 2 }}>
         {" "}
         <Box
            sx={{
               height: "auto",
               pt: 1.4,
               pl: 1,
               boxShadow: "0px 2px #E4EAF2",
               mt: -8,
            }}
         >
            <Typography sx={{ fontWeight: "bold", mb: 3 }}>
               Attachments
            </Typography>{" "}
            <List dense={false}>
               {files.map((file, index) => {
                  return (
                     <ListItem
                        key={index}
                        secondaryAction={
                           <>
                              <IconButton
                                 edge="end"
                                 aria-label="delete"
                                 onClick={() => handleDownloadFile(file)}
                                 sx={{ mr: 2 }}
                              >
                                 <DownloadRoundedIcon />
                              </IconButton>
                              <IconButton
                                 edge="end"
                                 aria-label="delete"
                                 onClick={() => handleDeleteFile(file)}
                              >
                                 <DeleteIcon />
                              </IconButton>
                           </>
                        }
                     >
                        <ListItemAvatar>
                           <Avatar sx={{ bgcolor: "darkred.main" }}>
                              <InsertDriveFileIcon
                                 sx={{ color: "grey.lighter" }}
                              />
                           </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                           primary={file.filePath ? file.filePath : file.name}
                           secondary={false ? "Secondary text" : null}
                        />
                     </ListItem>
                  );
               })}
            </List>
         </Box>
      </Box>
   );
}
